export const bottomRightArrowIcon = `
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.19613 1.98107L8.31655 1.98483L8.30126 7.66484L1.4362 0.799805L0.799805 1.4362L7.66317 8.29954L1.99829 8.31509L1.99446 9.19666L8.29659 9.17904L8.29613 9.18107L9.1757 9.17731L9.19613 1.98107Z" fill="#A1A1A1" stroke="#A1A1A1"/>
</svg>
`;
